export const DEV = 'http://localhost'
export const RECAPTCHA_V3_KEY_DEV = '6LfWHgkpAAAAAETuIN8mOSZck0cMJTmA53bzlgbQ'
//export const RECAPTCHA_V2_KEY_DEV = '6Ld9jLMqAAAAAOwMyl2XjL_y2ZAuldVmD8d8S4yK'
export const PROD = 'https://servicios.sitiodetiendas.com'
export const RECAPTCHA_V3_KEY_PROD = '6LdEaxopAAAAAOroQoiHhgVaRAcMbrXEmREziQid'
//export const RECAPTCHA_V2_KEY_PROD = ''
export const SUSCRIBE_ENABLED = true

export const ENV_URL = PROD
export const RECAPTCHA_KEY = RECAPTCHA_V3_KEY_PROD
